import { atomWithDebounce } from '@rematter/ui-web';
import type { Atom } from 'jotai';
import { atom } from 'jotai';

import { createDoNotBuyMutationAtom } from '../_graphql/mutationDoNotBuyCreate';
import { deleteDoNotBuyMutationAtom } from '../_graphql/mutationDoNotBuyDelete';
import { updateDoNotBuyMutationAtom } from '../_graphql/mutationDoNotBuyUpdate';
import type { DoNotBuyEntryRecord } from '../_graphql/queryDoNotBuyEntries';
import { queryDoNotBuyEntriesAtom } from '../_graphql/queryDoNotBuyEntries';

import type { QueryAtomReadValue } from '~/shared/providers/api/createQueryAtomFactory';

export const $doNotBuySearchTerm = atomWithDebounce('', 300);
export const $isDoNotBuyDialogOpen = atom(false);
export const $editingDoNotBuyEntry = atom<string | null>(null);

export const $rawDoNotBuyEntries = queryDoNotBuyEntriesAtom(() => ({}));

export const $doNotBuyEntries: Atom<QueryAtomReadValue<DoNotBuyEntryRecord[]>> =
  atom((get) => {
    const raw = get($rawDoNotBuyEntries);
    const searchTerms = get($doNotBuySearchTerm.debouncedValue)
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean);

    const data = (raw.data ?? []).filter((entry) => {
      if (searchTerms.length === 0) return true;
      const searchable = [
        entry.accountName,
        entry.reason,
        entry.status,
        entry.notes,
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      return searchTerms.every((term) => searchable.includes(term));
    });

    return { ...raw, data };
  });

export const $createDoNotBuy = createDoNotBuyMutationAtom({
  onSuccess: (get) => {
    get($rawDoNotBuyEntries).refetch?.();
  },
});

export const $updateDoNotBuy = updateDoNotBuyMutationAtom({
  onSuccess: (get) => {
    get($rawDoNotBuyEntries).refetch?.();
  },
});

export const $deleteDoNotBuy = deleteDoNotBuyMutationAtom({
  onSuccess: (get) => {
    get($rawDoNotBuyEntries).refetch?.();
  },
});
